import { FormRule } from "../interfaces/FormRule.interface";

/**
 * Add rule to existing rules object.
 * @param rules
 * @param watchTarget
 * @param setTarget
 * @param rule
 */
export function addRule(rules: any, watchTarget: string, setTarget: string, rule: FormRule) {
    if (!rules[watchTarget]) rules[watchTarget] = {};                           // Create ruleset if none exists.
    if (!rules[watchTarget][setTarget]) rules[watchTarget][setTarget] = rule;   // Add rule to ruleset if no rule exists at setTarget.
    else {
        // Determine if rule is unique.
        const existingRule = rules[watchTarget][setTarget];                                                     // Get existing rule for setTarget.
        const allExistingRules = [existingRule].concat(existingRule.all || []).map(e => JSON.stringify(e));     // Get array of JSON rules from existing rule (only works on stringables).
        const isUnique = allExistingRules.indexOf(JSON.stringify(rule)) < 0;                                    // Check JSON array for new rule.

        // Add new rule to existing rule.
        if (isUnique) rules[watchTarget][setTarget] = { all: existingRule.all ? existingRule.all.concat(rule) : [existingRule, rule] };
    }
    return rules;
}
